export default {
  api: 'https://wp.banjo2.emerson.edu/',
  mapbox: 'pk.eyJ1Ijoibmlja2ZvcmRkZXNpZ24iLCJhIjoiWlhxWDdUNCJ9.pnGwac6qU_VDgGfhGJ9EbQ',
  recaptcha: '6Ld14aUiAAAAAPd7A2CobYkOHCiuYdbC9o0Lo4t4'
}
